// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as V2f$Linear from "./V2f.res.js";
import * as M22f$Linear from "./M22f.res.js";
import * as LineSegment$Linear from "./LineSegment.res.js";

let jsonCodec = LineSegment$Linear.jsonCodec(Jzon.float);

function toVec(param) {
  return V2f$Linear.minus(param.to, param.from);
}

function intersectLine(lineA, lineB) {
  let match = lineB.to;
  let dy = match[1];
  let dx = match[0];
  let match$1 = lineB.from;
  let cy = match$1[1];
  let cx = match$1[0];
  let match$2 = lineA.to;
  let by = match$2[1];
  let bx = match$2[0];
  let match$3 = lineA.from;
  let ay = match$3[1];
  let ax = match$3[0];
  let cLeftAB = Math.sign(M22f$Linear.det([
    [
      ax - cx,
      ay - cy
    ],
    [
      bx - cx,
      by - cy
    ]
  ])) | 0;
  let dLeftAB = Math.sign(M22f$Linear.det([
    [
      ax - dx,
      ay - dy
    ],
    [
      bx - dx,
      by - dy
    ]
  ])) | 0;
  let aLeftCD = Math.sign(M22f$Linear.det([
    [
      cx - ax,
      cy - ay
    ],
    [
      dx - ax,
      dy - ay
    ]
  ])) | 0;
  let bLeftCD = Math.sign(M22f$Linear.det([
    [
      cx - bx,
      cy - by
    ],
    [
      dx - bx,
      dy - by
    ]
  ])) | 0;
  if ((cLeftAB * -1 | 0) === dLeftAB) {
    return (aLeftCD * -1 | 0) === bLeftCD;
  } else {
    return false;
  }
}

function intersectCircle(line, circle) {
  let d = toVec(line);
  let f = V2f$Linear.minus(line.from, circle.pos);
  let a = V2f$Linear.quadrance(d);
  let b = 2 * V2f$Linear.dot(f, d);
  let c = V2f$Linear.quadrance(f) - circle.radius * circle.radius;
  let discriminant = b * b - 4 * a * c;
  if (discriminant < 0) {
    return false;
  }
  let discriminantSqrt = Math.sqrt(discriminant);
  let a2 = 2 * a;
  let negB = - b;
  let t1 = (negB - discriminantSqrt) / a2;
  let t2 = (negB + discriminantSqrt) / a2;
  if (t1 >= 0 && t1 <= 1) {
    return true;
  } else if (t2 >= 0) {
    return t2 <= 1;
  } else {
    return false;
  }
}

export {
  jsonCodec,
  toVec,
  intersectLine,
  intersectCircle,
}
/* jsonCodec Not a pure module */
